import React, { Component } from "react";
import { Table, Icon } from "semantic-ui-react";
import axios from "axios";
import DownloadModal from './DownloadModal';

 var url = "https://encontech.azurewebsites.net/api/jobs";
 var downloadUrl = "https://encontech.azurewebsites.net/api/file/";
//var url = "http://localhost:5000/api/jobs";
//var downloadUrl = "http://localhost:5000/api/file/";
class JobTable extends Component {
  state = {
    jobData:[]
  };

  componentDidMount() {
  
    axios.get(url).then((response) => {
      this.setState({
        jobData: response.data,
      });
    });
  }

  ValidContract(contract: boolean, expirationDate: Date){
    var expDate = (new Date(expirationDate)).getTime();
    var today = (new Date()).getTime();
    console.log('contract: ' + contract);
    console.log('expiration: ' + expDate);
    console.log('today: ' + today);
    if(contract && (expDate === 0)) 
        return true;
    else if(contract && (expDate > today)) 
        return true;
    else 
        return false;
  }

  ContractDisplay(contract: boolean, expirationDate: Date){
    var expDate = (new Date(expirationDate)).getTime();
    var today = (new Date()).getTime();
    if(contract && (expDate === 0)) return "YES";
    else if(contract && (expDate > today)) return "YES";
    else if(contract) return "EXPIRED";
    else return "NO";
  }

  render() {
    return (

        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Address</Table.HeaderCell>
              <Table.HeaderCell>Brand</Table.HeaderCell>
              <Table.HeaderCell>Version</Table.HeaderCell>
              <Table.HeaderCell>Contract Start Date</Table.HeaderCell>
              <Table.HeaderCell>Contract End Date</Table.HeaderCell>
              <Table.HeaderCell>Comments</Table.HeaderCell>
              <Table.HeaderCell>Alarm Form</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {this.state.jobData.map((job: any) => (
              <Table.Row key={job.id}>
                <Table.Cell>
                <a href={job.link} target="_blank" rel="noopener noreferrer" >{job.name} </a>
                </Table.Cell>
                <Table.Cell>{job.address}</Table.Cell>
                <Table.Cell>{job.brand}</Table.Cell>
                <Table.Cell>{job.version}</Table.Cell>
                <Table.Cell>{(job.contractStartDate == null) ? "" : new Date(job.contractStartDate).toLocaleDateString()}</Table.Cell>
                <Table.Cell>{(job.contractEndDate == null) ? "" : new Date(job.contractEndDate).toLocaleDateString()}</Table.Cell>
                <Table.Cell>{job.comments}</Table.Cell>
                <Table.Cell>
                <a href=
                  { (job.alarmFormFile == null) ? "" : downloadUrl + job.alarmFormFile.fileGuid } 
                  rel="noopener noreferrer" >
                  { (job.alarmFormFile == null) ? "" : job.alarmFormFile.fileName }
                </a>
                  
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
    )
  }
}
export default JobTable;